import { Card, Divider } from 'antd';
import { useEffect, useState } from 'react';
import SingleCurrency from './SingleCurrency';
import AddCurrency from './AddCurrency';
import {
	getContractAddress,
	getCurrencies,
	getDisabledCurrencyWithdrawals,
	getDisabledCurrencyDeposits,
} from '../../methods/redux/reducers/currency';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';

const SupportedCurrencies = () => {
	const dispatch = useAppDispatch();
	const [refresh, setRefresh] = useState('');
	const { currencies } = useAppSelector((store: any) => store.currencies);

	useEffect(() => {
		dispatch(getCurrencies({}));
		dispatch(getContractAddress({}));
		dispatch(getDisabledCurrencyWithdrawals({ isDisabled: 'true' }));
		dispatch(getDisabledCurrencyDeposits({ isDisabled: 'true' }));
	}, [refresh]);

	return (
		<Card>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'flex-start',
				}}
			>
				<h1>Supported Currencies</h1>
				<AddCurrency />
			</div>
			<Divider />
			{currencies.map((currency: any) => (
				<SingleCurrency
					key={currency._id}
					data={currency}
					setRefresh={setRefresh}
				/>
			))}
		</Card>
	);
};

export default SupportedCurrencies;
